module.exports = __webpack_public_path__ + "img/calligraphy-work-icon1.01117e44.jpg";